import * as React from 'react';
import {Provider} from 'react-redux';
import '@pluto-tv/assemble/dist/style.css';

import Layout from 'app/layout/Main';

import {store} from './store';
import './App.css';

export default (): JSX.Element => {
  return (
    <Provider store={store}>
      <Layout />
    </Provider>
  );
};
